<template>
  <div>
    <b-card class="border-none">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <AddPageDetail />
        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Role Management
          </h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <base-button outline class="px-6 py-1 mx-1" type="primary">
            <span class="btn-inner--text flex"
              ><feather-icon
                icon="UploadIcon"
                class="mr-2 cust-HW"
              ></feather-icon
              >Export</span
            >
          </base-button>
          <!-- <base-button
            outline
            type="success"
            class="flex custpad5-10 mx-1"
            @click="shownewpage = true"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
            Student
          </base-button> -->
        </div>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class=" cursor-pointer  mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="Data"
      >
        <el-table-column label="Sr no." prop="srno" min-width="130px" sortable>
        </el-table-column>

        <el-table-column
          label="First Name"
          min-width="150px"
          prop="subtitle"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.subtitle }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Last Name."
          min-width="130px"
          prop="orderno"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="User ID"
          min-width="170px"
          prop="imgurl"
          sortable
        >
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.imgurl }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Role" min-width="170px" prop="tags" sortable>
          <template v-slot="{ row }">
            <span class=" text-black ">{{ row.tags }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Action" min-width="130px">
          <div class="flex items-center">
            <base-button
              class="px-4 py-1 mx-1"
              type="primary"
              v-if="!approve"
              @click="approve = true"
            >
              Approve
            </base-button>
            <base-button
              class="px-4 py-1 mx-1"
              type="danger"
              v-show="approve"
              @click="approve = false"
            >
              Reject
            </base-button>
          </div>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import Data from "./components/Data";

import AddStudDashboard from "./components/AddRoleManage.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    AddStudDashboard
  },
  data() {
    return {
      Data,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      approve: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
